// extracted by mini-css-extract-plugin
export default {"lntModalFooter":"styles_lnt-modal-footer__9ktrk"};